var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Strong } from '../Text';
import styled from '../utils/styled-components';
import hintTheme from './theme';
import { ComponentThemeProvider } from '../ThemeProvider';
import getIconSet from '../utils/getIconSet';
var ERROR = 'error';
var INFO = 'info';
var SUCCESS = 'success';
var WARNING = 'warning';
var StyledLabel = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: ", ";\n  color: ", ";\n  font-size: ", ";\n  background-color: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  padding: ", ";\n  color: ", ";\n  font-size: ", ";\n  background-color: ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.hint.padding;
}, function (_a) {
    var level = _a.level, component = _a.theme.component;
    return component.hint[level].text;
}, function (_a) {
    var component = _a.theme.component;
    return component.hint.fontSize;
}, function (_a) {
    var level = _a.level, component = _a.theme.component;
    return component.hint[level].background;
});
var iconSet = getIconSet();
var Attention = iconSet.Warning, Check = iconSet.Checkmark, Danger = iconSet.Warning, Info = iconSet.Information;
/**
 * Helper for render the right icon based on the properties
 */
var renderIcon = function (level) {
    switch (level) {
        case ERROR:
            return React.createElement(Attention, { size: "1rem" });
        case SUCCESS:
            return React.createElement(Check, { size: "1rem" });
        case WARNING:
            return React.createElement(Danger, { size: "1rem" });
        default:
            return React.createElement(Info, { size: "1rem" });
    }
};
var Label = function (_a) {
    var level = _a.level;
    return React.createElement(StyledLabel, { level: level }, renderIcon(level));
};
var Content = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: ", ";\n  ", "\n"], ["\n  padding: ", ";\n  ", "\n"])), function (_a) {
    var component = _a.theme.component;
    return component.hint.padding;
}, function (_a) {
    var spaced = _a.spaced;
    return spaced && 'padding-left: 0;';
});
/**
 * Helper for render the right text based on the properties
 */
var renderText = function (level) {
    switch (level) {
        case ERROR:
            return React.createElement(FormattedMessage, { defaultMessage: "Error:", id: "hint.error" });
        case SUCCESS:
            return React.createElement(FormattedMessage, { defaultMessage: "Success:", id: "hint.success" });
        case WARNING:
            return React.createElement(FormattedMessage, { defaultMessage: "Warning:", id: "hint.warning" });
        default:
            return React.createElement(FormattedMessage, { defaultMessage: "Info:", id: "hint.info" });
    }
};
var StyledHint = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  color: ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n"], ["\n  display: flex;\n  color: ", ";\n  background-color: ",
    ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n"])), function (_a) {
    var level = _a.level, component = _a.theme.component;
    return component.hint[level].text;
}, function (_a) {
    var level = _a.level, light = _a.light, inline = _a.inline, component = _a.theme.component;
    return light && !inline ? 'none' : component.hint[level].background;
}, function (_a) {
    var level = _a.level, component = _a.theme.component;
    return component.hint[level].border;
}, function (_a) {
    var theme = _a.theme;
    return theme.global.borderRadius;
});
export var Hint = function (_a) {
    var children = _a.children, className = _a.className, inline = _a.inline, level = _a.level, light = _a.light, testId = _a.testId;
    if (inline) {
        return (React.createElement(ComponentThemeProvider, { theme: hintTheme },
            React.createElement(StyledHint, { className: className, "data-testid": testId, inline: true, level: level },
                React.createElement(Content, { spaced: true },
                    React.createElement(Strong, null, renderText(level)),
                    " ",
                    children))));
    }
    return (React.createElement(ComponentThemeProvider, { theme: hintTheme },
        React.createElement(StyledHint, { className: className, "data-testid": testId, level: level, light: light },
            React.createElement(Label, { level: level }),
            React.createElement(Content, { spaced: light }, children))));
};
export var ErrorHint = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Hint, __assign({}, props, { level: ERROR }), children));
};
export var InfoHint = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Hint, __assign({}, props, { level: INFO }), children));
};
export var SuccessHint = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Hint, __assign({}, props, { level: SUCCESS }), children));
};
export var WarningHint = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Hint, __assign({}, props, { level: WARNING }), children));
};
export default Hint;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map